var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenuNew(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0L14.4288 2.93575L18 1.6077L18.6355 5.36451L22.3923 6L21.0642 9.57124L24 12L21.0642 14.4288L22.3923 18L18.6355 18.6355L18 22.3923L14.4288 21.0642L12 24L9.57124 21.0642L6 22.3923L5.36451 18.6355L1.6077 18L2.93575 14.4288L0 12L2.93575 9.57124L1.6077 6L5.36451 5.36451L6 1.6077L9.57124 2.93575L12 0Z",
    fill: "url(#paint0_linear_10352_16255)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3036 13.8897L16.6981 11.4603L16.141 13.8897H14.4294L13.4929 10.1099H14.9058L15.479 12.6493L16.0603 10.1099H17.5619L18.1674 12.5319L18.7164 10.1099H20.0001L19.0636 13.8897H17.3036Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0237 13.0459C11.4032 13.0459 11.6212 12.9064 11.6373 12.5835H13.2116C13.1147 13.5523 12.3235 14 11.0237 14C9.61896 14 8.88428 13.4495 8.88428 12.0183C8.88428 10.5578 9.62703 10 11.0237 10C12.4769 10 13.2116 10.5358 13.2116 11.9229V12.1798H10.4182V12.3706C10.4182 12.9064 10.6685 13.0459 11.0237 13.0459ZM11.6373 11.4459V11.4385C11.6373 11.1083 11.4274 10.9541 11.0237 10.9541C10.6443 10.9541 10.4182 11.1083 10.4182 11.4385V11.4459H11.6373Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.70458 13.8899V11.4312C6.70458 11.1083 6.53504 11.0055 6.13945 11.0055C5.80844 11.0055 5.57431 11.1083 5.57431 11.4312V13.8899H4V10.1101H5.53394V10.6459C5.75192 10.2055 6.2444 10 6.85798 10C7.77834 10 8.27889 10.4477 8.27889 11.4312V13.8899H6.70458Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10352_16255",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E30611"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuNew);
export default __webpack_public_path__ + "static/media/menu-new.5a2c020a.svg";
export { ForwardRef as ReactComponent };